"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = envSuffix;

var _enviro = _interopRequireDefault(require("enviro"));

function envSuffix() {
  return _enviro.default.getShort() === 'qa' ? 'qa' : '';
}

module.exports = exports.default;